import React from 'react';

export default function BurgerButton({isOpen, onClick, productsCount}) {
    return (
        <div
            className={
                `button__burger ${isOpen ?
                    'openBurger'
                    : ''} visible-mobile`
            }
            onClick={onClick}
        >
            {productsCount > 0 && (
                <div className={`header_count ${isOpen ? "hidden":""}`}></div>
            )}
        </div>
    )
}
